import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Jobs from '../components/jobs/jobs'

import * as docsActions from '../actions/docs'
import * as jobsActions from '../actions/jobs'

function mapStateToProps(state) {
    return {
        appState: state.appState,
        account: state.account,
        docs: state.docs,
        jobs: state.jobs,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        docsActions: bindActionCreators(docsActions, dispatch),
        jobsActions: bindActionCreators(jobsActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Jobs)



// WEBPACK FOOTER //
// ./app/containers/jobs.js